import { IonIcon, IonItem } from '@ionic/react';
import styled from 'styled-components';

export const CollapsibleContent = styled.div<{
  isOpen: boolean;
  $fullWidth?: boolean;
  $overflow?: boolean;
}>`
  max-height: ${(props) => (props.isOpen ? '1000px' : '0')};
  overflow: ${(props) => (props.$overflow ? 'auto' : 'hidden')};
  transition: max-height 0.3s ease-in-out;
  display: ${(props) => (props.$fullWidth ? 'block' : 'flex')};
  width: ${(props) => (props.$fullWidth ? '100%' : 'auto')};
  box-sizing: border-box;
`;

export const RotatingIcon = styled(IonIcon as any)<{ isOpen: boolean }>`
  transition: transform 0.3s ease-in-out;
  transform: ${(props) => (props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
`;

export const CardContainer = styled.div<{ $fullWidth?: boolean }>`
  border-radius: 8px !important;
  align-content: center;
  overflow: hidden;
  box-shadow: none;
  border: 1px solid var(--allie-color-neutral-30);
  align-items: center;
  background: var(--allie-color-light-main);
  height: 100%;
  width: ${(props) => (props.$fullWidth ? '100%' : 'auto')};
  box-sizing: border-box;
`;

export const StyledItem = styled(IonItem as any)`
  width: 100%;
  --inner-padding-start: var(--allie-spacing-xl) --inner-padding-end: var(--allie-spacing-xl);
`;
